import getCurrentEventMailboxSmtpAddress from 'owa-calendar-compose-form-store/lib/selectors/getCurrentEventMailboxSmtpAddress';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import type SingleRecipientType from 'owa-service/lib/contract/SingleRecipientType';

/**
 * gets the from address using Organizer info. If the address doesn't exist in the event,
 * it is defaulted to the current user in the session-store
 */
export default function getFromAddress(organizer?: SingleRecipientType): string {
    let fromAddress: string;
    if (organizer) {
        fromAddress = organizer.Mailbox.EmailAddress;
    } else {
        const mailboxSmtp = getCurrentEventMailboxSmtpAddress();
        fromAddress = mailboxSmtp ?? getUserConfiguration().SessionSettings.UserEmailAddress;
    }

    return fromAddress;
}
